import Collapse from "@material-ui/core/Collapse";
import IconButton from "@material-ui/core/IconButton";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import { FieldArray } from "formik";
import React, { useState } from "react";
import { Container } from "react-bootstrap";
import { useBranchCourseContext } from "../BranchCourseDataContext";
import { BranchCourseFeeEditRow } from "./BranchCourseFeeEditRow";
import {
  CAMP_CAMP_IND,
  getNewRowFrequencyUnit,
  getNewRowVirtualFee,
} from "./feeCourseKind";

export const BranchCampFeeEditTableRow = ({
  values,
  errors,
  touched,
  deleted,
  setDeleted,
  bt,
  TYPE,
  isSchool = false,
}) => {
  const DROPDOWN_TYPE = useBranchCourseContext().TYPES;
  const [open, setOpen] = useState(false);
  const [batchTypeOpen, setBatchTypeOpen] = useState("");

  const handleRowClick = (id) => {
    setOpen(!open);
    setBatchTypeOpen(id);
  };

  // Defaults match what the row's selects show, so a row saved untouched
  // inserts what the admin saw. The first row on a course with no fees is
  // pre-ticked for the price range (the form requires one).
  const isFirstRow = values.fees.length === 0;
  // School default rows are keyed on the branch course alone: no frequency,
  // half-day or duration discrimination, and one row per branch course.
  const empty_row = isSchool
    ? {
        frequency_unit: "custom",
        frequency_nbr: null,
        half_day_ind: 0,
        added_fee: 0,
        delivery_type_id: 1,
        course_fee: "",
        virtual_course_fee: getNewRowVirtualFee(values),
        price_range_ind: 1,
        branch_course_fee_id: null,
        batch_type: bt.id,
      }
    : {
        frequency_unit: getNewRowFrequencyUnit(values, CAMP_CAMP_IND),
        frequency_nbr: 1,
        half_day_ind: false,
        delivery_type_id: 1,
        virtual_course_fee: getNewRowVirtualFee(values),
        price_range_ind: isFirstRow ? 1 : 0,
        branch_course_fee_id: null,
        batch_type: bt.id,
      };
  // The camp cap assumes several camp batch types; a school course gets
  // exactly one default row.
  const rowsInSection = values.fees.filter((fee) => fee.batch_type == bt.id)
    .length;
  const canAddRow = isSchool
    ? rowsInSection < 1
    : TYPE == 1 || values.fees.length < 8 * (DROPDOWN_TYPE.BATCH_TYPE.length - 1);
  // A saved course keeps at least one fee row, but an unsaved row can always
  // be dropped (e.g. the first row added to a course that has none).
  const removeRow = (branch_course, remove, index) => {
    if (values.fees.length > 1 || branch_course.branch_course_fee_id == null) {
      remove(index);
      if (branch_course.branch_course_fee_id != null) {
        deleted
          ? setDeleted([...deleted, branch_course.branch_course_fee_id])
          : setDeleted([branch_course.branch_course_fee_id]);
      }
    }
  };
  return (
    <>
      <TableRow>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => handleRowClick(bt.id)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            {bt.value}
          </IconButton>
        </TableCell>
      </TableRow>
      <TableRow>
        <Collapse in={open} timeout="auto" unmountOnExit>
          <Container>
            <FieldArray name="fees">
              {({ push, remove }) => {
                return (
                  <span>
                    <div className="table table-striped">
                      <div className="thead-light">
                        {isSchool ? (
                          <div className="row">
                            <div className="col-lg-3">Delivery Type</div>
                            <div className="col-lg-3">Stream Fee</div>
                            <div className="col-lg-2">Display in Range</div>
                            <div className="col-lg-1">Actions</div>
                          </div>
                        ) : (
                          <div className="row">
                            <div className="col-lg-2">Delivery Type</div>
                            <div className={TYPE == 1 ? "col-lg-2" : "col-lg-3"}>
                              Batch Type
                            </div>
                            <div className="col-lg-2">
                              Sessions/{TYPE != 1 ? "week" : "month"}
                            </div>
                            {TYPE == 1 && (
                              <div className="col-lg-2">Duration</div>
                            )}
                            <div className={TYPE == 1 ? "col-lg-2" : "col-lg-1"}>
                              Stream Fee
                            </div>
                            {TYPE != 1 && (
                              <div className="col-lg-1">Extended Care Fee</div>
                            )}
                            {TYPE != 1 && <div className="col-lg-1">HD Ind</div>}
                            <div className={TYPE == 1 ? "col-lg-1" : "col-lg-1"}>
                              Display in Range
                            </div>
                            <div className="col-lg-1">Actions</div>
                          </div>
                        )}
                      </div>
                      <div className="tbody">
                        {values &&
                          values.fees.length > 0 &&
                          values.fees.map((fee, index) => {
                            const feesErrors =
                              (errors.fees?.length && errors.fees[index]) || {};
                            const feesTouched =
                              (touched.fees?.length && touched.fees[index]) ||
                              {};
                            return fee.batch_type == bt.id ? (
                              <BranchCourseFeeEditRow
                                type={TYPE}
                                isSchool={isSchool}
                                key={index}
                                fee={fee}
                                errors={feesErrors}
                                touched={feesTouched}
                                index={index}
                                removeRow={removeRow}
                                remove={remove}
                              ></BranchCourseFeeEditRow>
                            ) : null;
                          })}
                      </div>
                    </div>
                    <button
                      type="button"
                      className="btn btn-primary"
                      disabled={isSchool && !canAddRow}
                      onClick={() => {
                        canAddRow && push(empty_row);
                      }} // insert an empty string at a position
                    >
                      {isSchool
                        ? canAddRow
                          ? "Add Default Fee"
                          : "Max # Rows Reached"
                        : TYPE == 1 ||
                          values.fees.length <
                            1000 * (DROPDOWN_TYPE.BATCH_TYPE.length - 1)
                        ? "Add New Fee"
                        : "Max # Rows Reached"}
                    </button>
                    {isSchool && (
                      <div className="text-muted font-size-sm mt-2">
                        One default fee per stream at this branch. School
                        programs inherit it unless the program sets a custom
                        fee.
                      </div>
                    )}
                  </span>
                );
              }}
            </FieldArray>
          </Container>
        </Collapse>
      </TableRow>
    </>
  );
};
